import { render } from "./App.vue?vue&type=template&id=27e8c013"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=27e8c013&lang=scss"

import exportComponent from "/srv/http/cv.mzubiaga.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__